export interface WebhookDTO {
  id: number;
  name: string;
  url: string;
  action: WebhookActionDto;
}

export interface WebhookActionDto {
  id?: number;
  name?: string;
  description?: string;
  entityType?: string;
  action?: string;
  intent?: string;
}

export enum WebhookEntityType {
  ACTIVITY = 'Activity',
}

export enum WebhookActionType {
  STATUS_UPDATE = 'STATUS_UPDATE',
  REQUEST = 'REQUEST',
  PRE_REQUEST = 'PRE_REQUEST',
  CANCEL_REQUEST = 'CANCEL_REQUEST',
}

export const WebhookEntityTypeMap: Record<WebhookEntityType, WebhookActionType[]> = {
  [WebhookEntityType.ACTIVITY]: [WebhookActionType.STATUS_UPDATE, WebhookActionType.REQUEST, WebhookActionType.PRE_REQUEST, WebhookActionType.CANCEL_REQUEST],
};

export interface WebhookLogDTO {
  id: number;
  url?: string | null;
  webhookAction: WebhookActionDto;
  requestBody: unknown;
  response?: unknown;
  httpStatusCode?: number;
  timestamp: string;
}
